import { Component } from '@angular/core';

@Component({
  selector: 'app-longgoldbar-dialog',
  templateUrl: './longgoldbar-dialog.component.html',
  styleUrls: ['./longgoldbar-dialog.component.css']
})
export class LonggoldbarDialogComponent {

}
